export default "__VITE_ASSET__YSDCadbm__"